"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateAndTimeTranslations = {
    "en": {
        time: "Time",
        startDayOf: "Start of day",
        endDayOf: "End of day",
        noon: "noon",
    },
    "de": {
        startDayOf: "Tagesbeginn",
        endDayOf: "Tagesende",
        noon: "Mittag",
        time: "Zeit",
    },
    "nl": {
        startDayOf: "Begin van de dag",
        endDayOf: "Eind van de dag",
        noon: "middag",
        time: "Tijd",
    },
    "it": {
        startDayOf: "Inizio della giornata",
        endDayOf: "Fine della giornata",
        noon: "pomeriggio",
        time: "Orario",
    },
    "fr": {
        startDayOf: "Début de la journée",
        endDayOf: "Fin de la journée",
        noon: "midi",
        time: "Heure",
    },
    "es": {
        startDayOf: "Inicio del día",
        endDayOf: "Final del día",
        noon: "mediodía",
        time: "Hora",
    },
    "ja": {
        startDayOf: "始業",
        endDayOf: "終業",
        noon: "正午",
        time: "時刻",
    },
    "en-GB": {
        startDayOf: "Start of day",
        endDayOf: "End of day",
        noon: "noon",
        time: "Time",
    },
    "ru": {
        time: "Время",
        startDayOf: "Начальное время",
        endDayOf: "Конечное время",
        noon: "полдень",
    },
};
